// TODO import/export functionality
import React from 'react';
import PropTypes from 'prop-types';
const orderBy = require('lodash/orderBy');
const uuid = require('uuid');
import { Form, InputGroup, Button } from 'react-bootstrap';

const Globals = require('../../../../../app/globals');
const Strings = require('../../../../../app/shared/Strings');
const ActivityActions = require('../../../actions/ActivityActions');
const ActivityStore = require('../../../stores/activity_store_reflux');
// const OrganizationActions = require('../../../actions/OrganizationActions');
const AssetUtil = require('../../../util/asset');
import ErrorBox from '../../common/ErrorBox';
import ConfirmModal from '../../modal/ConfirmModal';
import SortableTableClassic from '../../table/SortableTableClassic';
import OrgActMetaTypeEditor from './OrgActMetaTypeEditor';
import ExpandableWell from '../../common/ExpandableWell';
import { DeleteTypeWarning } from './OrgMetaTagInfoWarnings';
import SingleAssetInput from '../../common/SingleAssetInput';
// import WithOrganizationActivityMetaTagImportChanges from '../../DataHOCs/WithOrganizationActivityMetaTagImportChanges';
// import OrgActMetaTagImportChanges from './OrgActMetaTagImportChanges';

const propTypes = {
    className: PropTypes.string,
    orgId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    types: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        type_display_name: PropTypes.string.isRequired,
        created_at: PropTypes.string.isRequired,
    })),
    // orgActMetaImportChanges: PropTypes.shape({
    //     tagsToAdd: PropTypes.array,
    //     tagsToDelete: PropTypes.array,
    //     tagsToUpdate: PropTypes.array,
    //     existingTagsHash: PropTypes.string.isRequired,
    // }),
};
const defaultProps = {
    className: '',
    types: {},
};

class OrgActMetaTypesEditor extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedTypeId: null,
            addTypeError: null,
            addTypeActionId: null,
            deleteTypeError: null,
            deleteTypeActionId: null,
            updateTypeError: null,
            updateTypeActionId: null,
            typeToDelete: null,
            newType: '',
            // importTagsActionId: null,
            // importTagsError: null,
        };

        this.onAddType = this.onAddType.bind(this);
        this.onDeleteType = this.onDeleteType.bind(this);
        this.onUpdateNewType = this.onUpdateNewType.bind(this);
        this.setConfirmDeleteTypeModalState = this.setConfirmDeleteTypeModalState.bind(this);
        this.onActiveTypeClick = this.onActiveTypeClick.bind(this);
        this.onUpdateType = this.onUpdateType.bind(this);
        this.onDeselectType = this.onDeselectType.bind(this);
        // this.getExportCsvHref = this.getExportCsvHref.bind(this);
        // this.importCsv = this.importCsv.bind(this);
        this.unsubscribes = [
            ActivityStore.listen(this.onActivityStoreChange.bind(this))
        ];
    }

    // UNSAFE_componentWillReceiveProps(nextProps) {        
    //     if (nextProps.organizationStoreAction.id === this.state.importTagsActionId) {
    //         this.setState({
    //             importTagsActionId: null,
    //             importTagsError: nextProps.organizationStoreAction.error || null,
    //         });
    //     }
    // }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onActivityStoreChange(newState) {
        if (newState.action.id === this.state.addTypeActionId) {
            let updatedState = { addTypeActionId: null };

            if (newState.action.error) {
                updatedState = { ...updatedState, addTypeError: newState.action.error };
            }
            else {
                updatedState = { ...updatedState, newType: '', addTypeError: null };
            }

            this.setState(updatedState);
        }
        else if (newState.action.id === this.state.deleteTypeActionId) {
            let updatedState = {
                deleteTypeActionId: null,
                confirmDeleteTypeModal: false,
                typeToDelete: null,
            };

            if (newState.action.error) {
                updatedState = { ...updatedState, deleteTypeError: newState.action.error };
            }
            else {
                updatedState = { ...updatedState, selectedTypeId: null, deleteTypeError: null };
            }

            this.setState(updatedState);
        }
        else if (newState.action.id === this.state.updateTypeActionId) {
            let updatedState = {
                updateTypeActionId: null,
            };

            if (newState.action.error) {
                updatedState = { ...updatedState, updateTypeError: newState.action.error };
            }
            else {
                updatedState = { ...updatedState, updateTypeError: null };
            }

            this.setState(updatedState);
        }
    }

    onAddType() {
        const addTypeActionId = uuid.v4();
        this.setState({ addTypeActionId: addTypeActionId }, () => {
            ActivityActions.addOrgActMetaType(
                addTypeActionId,
                {
                    orgId: this.props.orgId,
                    displayName: this.state.newType,
                }
            );
        });
    }

    onUpdateNewType(e) {
        this.setState({ newType: e.target.value });
    }

    onDeleteType(typeId) {
        const deleteTypeActionId = uuid.v4();
        this.setState({ deleteTypeActionId: deleteTypeActionId }, () => {
            ActivityActions.deleteActMetaType(
                deleteTypeActionId,
                {
                    orgId: this.props.orgId,
                    typeId: typeId,
                }
            );
        });
    }

    setConfirmDeleteTypeModalState(showBool, typeToDelete) {
        this.setState({ confirmDeleteTypeModal: showBool, typeToDelete: showBool ? typeToDelete : null });
    }

    onActiveTypeClick(e, typeId) {
        let additionalState = {};
        if (typeId !== this.state.selectedTypeId) {
            additionalState = {
                updateTypeActionId: null,
                updateTypeError: null,
            };
        }

        this.setState({ ...additionalState, selectedTypeId: typeId });
    }

    onDeselectType() {
        this.setState({
            selectedTypeId: null,
            updateTypeActionId: null,
            updateTypeError: null,
        });
    }

    onUpdateType(typeRecord, newTypeName) {
        const updateTypeActionId = uuid.v4();
        this.setState({ updateTypeActionId: updateTypeActionId }, () => {
            ActivityActions.updateActMetaType(
                updateTypeActionId,
                {
                    orgId: this.props.orgId,
                    typeId: typeRecord.id,
                    displayName: newTypeName,
                }
            );
        });
    }

    // getExportCsvHref() {
    //     return `/authoring/organization/${this.props.orgId}/activity_tags/${this.props.category.id}/csv`;
    // }

    // importCsv(params, files) {
    //     const importTagsActionId = uuid.v4();
    //     this.setState({ importTagsActionId: importTagsActionId }, () => {
    //         params = {
    //             ...params,
    //             orgId: this.props.orgId,
    //             categoryId: this.props.categoryId,
    //         };

    //         OrganizationActions.importActMetaTagsCsv(importTagsActionId, params, files);
    //     });
    // }

    render() {
        const tableColumns = [
            {
                displayName: Strings['en'].act_meta_types.TYPE_NAME,
                key: 'type_display_name',
                size: 2,
                type: 'string',
                caseSensitive: true,
            },
            {
                displayName: Strings['en'].act_meta_types.ATTACHED_ACTS,
                key: 'usage_count',
                size: 1,
                type: 'number',
            },
            {
                displayName: Strings['en'].common.CREATED_AT,
                key: 'created_at',
                size: 3,
                type: 'date'
            }
        ];

        const defaultSort = { key: 'type_display_name', type: 'string', asc: true };
        const selectedType = !!this.state.selectedTypeId ? this.props.types.find(type => type.id === this.state.selectedTypeId) : null;

        return (
            <div className={this.props.className}>
                <h2 className="large-heading-regular margin-bottom-lg">
                    {Strings['en'].act_meta_tags.CATEGORY}: <strong className="font-weight-bold">{Strings['en'].act_meta_types.ACTIVITY_TYPE}</strong>
                </h2>
                <ul className="metaTagEditorCategoryDesc">
                    <li>{Strings['en'].act_meta_types.CATEGORY_ORG_CONTROLLED_TYPE_DESC}</li>
                    <li>{Strings['en'].act_meta_types.CATEGORY_DISALLOW_MULT_DESC}</li>
                </ul>
                <ErrorBox error={this.state.addTypeError} />
                <ErrorBox error={this.state.deleteTypeError} />
                <Form className="margin-bottom-lg">
                    <Form.Group controlId={`add-act-meta-type}`}>
                        <Form.Label>{Strings['en'].act_meta_types.TYPE_DISPLAY_NAME}</Form.Label>
                        <InputGroup>
                            <Form.Control
                                value={this.state.newType}
                                onChange={this.onUpdateNewType}
                            />
                            <InputGroup.Append>
                                <Button 
                                    disabled={!this.state.newType}
                                    onClick={this.onAddType}
                                >
                                    {Strings['en'].common.ADD}
                                </Button>
                            </InputGroup.Append>
                        </InputGroup>
                    </Form.Group>
                </Form>

                {/* TODO
                <div className="margin-bottom-lg">
                    <ExpandableWell title="Import/Export">
                        <div className="margin-top-lg margin-bottom-xl">
                            <h3 className="md-heading margin-bottom-lg">Export Tags</h3>
                            <ExportTagsInfo
                                className="font-size-14px margin-bottom-lg line-height-16px"
                                categoryName={this.props.category.display_name}
                                requiresOrder={this.props.category.requires_order}
                            />
                            <div className="text-centered">
                                <a className="link-plain btn btn-primary d-inline-block" href={this.getExportCsvHref()}>
                                    {Strings['en'].common.EXPORT_CSV}
                                </a>
                            </div>
                        </div>
                        <div>
                            <h3 className="md-heading margin-bottom-lg">Import Tags</h3>
                            <ImportTagsInfo
                                className="font-size-14px margin-bottom-lg line-height-16px"
                                categoryName={this.props.category.display_name}
                                requiresOrder={this.props.category.requires_order}
                            />
                            {!this.props.orgActMetaImportChanges ?
                                <div>
                                    <ErrorBox error={this.state.importTagsError} />
                                    <div className="text-centered">
                                        <SingleAssetInput
                                            buttonOnly
                                            browseText="Import CSV"
                                            assetType="csv"
                                            assetRole="tags"
                                            accept="text/csv, .csv"
                                            disabled={!!this.props.orgActMetaImportChanges}
                                            onChange={this.importCsv}
                                            onError={(err) => {console.log(err)}}
                                            validateAssetType={AssetUtil.validateCsvMimeType}
                                        />
                                    </div>
                                    
                                </div>
                                :
                                <div className="bg-color-white padding-all-md">
                                    <h3 className="sm-heading margin-bottom-lg">Pending Changes From Import</h3>
                                    <div className="sub-heading">
                                        The imported changes have not yet been finalized. Please review and click 'Confirm Changes' to finalize.
                                    </div>
                                    <OrgActMetaTagImportChanges className="border-all-warn padding-all-md" orgId={this.props.orgId} categoryId={this.props.category.id} category={this.props.category} />
                                </div>
                            }
                        </div>
                    </ExpandableWell>
                </div>
                */}

                <SortableTableClassic
                    classNameTableContainer="margin-bottom-lg"
                    onRowClick={this.onActiveTypeClick}
                    rows={this.props.types}
                    selectedRowKey={this.state.selectedTypeId}
                    dateFormat="YYYY-MM-DD HH:mm z"
                    defaultSort={defaultSort}
                    tableHeight={500}
                    columns={tableColumns}
                />

                {(!!selectedType) &&
                    <div>
                        <ErrorBox error={this.state.updateTypeError} />
                        <OrgActMetaTypeEditor
                            className="margin-top-xl"
                            orgId={this.props.orgId}
                            typeRecord={selectedType}
                            onDelete={this.setConfirmDeleteTypeModalState.bind(this, true, selectedType)}
                            onUpdate={this.onUpdateType.bind(this, selectedType)}
                            onClose={this.onDeselectType}
                        />
                    </div>
                }

                {(this.state.confirmDeleteTypeModal) &&
                    <ConfirmModal
                        show={this.state.confirmDeleteTypeModal}
                        modalTitle={Strings['en'].act_meta_types.DELETE_TYPE}
                        text={
                            <DeleteTypeWarning
                                className="margin-top-sm font-weight-bold text-centered font-size-14px"
                                attachedActCount={this.state.typeToDelete.usage_count}
                            />
                        }
                        buttonText="confirm delete"
                        confirmButtonBsStyle="danger"
                        confirmHandler={this.onDeleteType.bind(this, this.state.typeToDelete.id)}
                        cancelButtonText="cancel"
                        cancelHandler={this.setConfirmDeleteTypeModalState.bind(this, false)}
                        closeHandler={this.setConfirmDeleteTypeModalState.bind(this, false)}
                    />
                }
            </div>
        );
    }
}

OrgActMetaTypesEditor.propTypes = propTypes;
OrgActMetaTypesEditor.defaultProps = defaultProps;

// export default WithOrganizationActivityMetaTagImportChanges(OrgActMetaTypesEditor);
export default OrgActMetaTypesEditor;